<template>
  <section class="attend">
    <div class="attend-content">
      <img src="../assets/img/circles.svg" width="250">

      <h2>{{ data.headline }}</h2>

      <a v-if="data.cta" class="btn large" :href="data.cta.url" target="_blank">{{ data.cta.title }}</a>

      <div class="links">
        <a :href="link.link.url" v-for="link in data.links" :key="link.url" class="link">
          <span class="link-name">{{ link.link.title }}</span>
        </a>
      </div>
    </div>

    <div class="attend-img">
      <img :src="data.featured_image.url" :alt="data.featured_image.alt">
    </div>
  </section>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style scoped lang="less">
@import '../css/variables';

.attend {
  margin-bottom: 40px;
  color: #fff;
  background-color: @themeColor2;
  @media (min-width: @mobile) {
    display: flex;
    justify-content: space-between;
  }
  .attend-content {
    width: 50%;
    padding: 60px;
    @media (max-width: @mobile) {
      padding: 40px 20px;
      width: 100%;
    }
    img {
      margin-bottom: 50px;
    }
    h2 {
      margin-bottom: 30px;
    }
    .btn {
      margin-bottom: 40px;
    }

    .links {
      display: grid;
      grid-template-columns: 1fr 1fr;
      row-gap: 45px;
      column-gap: 20px;
      .link {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 35px 10px;
        text-decoration: none;
        text-align: center;
        background-color: @themeColor3;
        .link-name {
          font-size: 22px;
          font-weight: bold;
          color: #fff;
          @media (max-width: @mobile) {
            font-size: 20px;
          }
        }
      }
    }
  }

  .attend-img {
    overflow: hidden;
    @media (min-width: 860px) {
      width: 50%;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Attend.vue